// RxJS
// NGRX
import { select, Store } from '@ngrx/store';

// State
import { AppState } from '../../../core/reducers';
// CRUD
import { BaseDataSource, QueryResultsModel } from '../../_base/crud';
import {
  selectKgCheckReportInStore,
  selectKgCheckReportPageLoading,
  selectKgCheckReportShowInitWaitingMessage,
} from '../_selectors/kg_check_report.selectors';

export class KgCheckReportDataSource extends BaseDataSource {
  constructor(private store: Store<AppState>) {
    super();

    this.loading$ = this.store.pipe(select(selectKgCheckReportPageLoading));

    this.isPreloadTextViewed$ = this.store.pipe(
      select(selectKgCheckReportShowInitWaitingMessage)
    );

    this.store
      .pipe(select(selectKgCheckReportInStore))
      .subscribe((response: QueryResultsModel) => {
        this.paginatorTotalSubject.next(response.totalCount);
        this.entitySubject.next(response.items);
      });
  }
}
